import BaseItemView from 'app/src/views/base/BaseItemView';

import buttonViewTemplate from './templates/button-view.hbs';

let _Events = {
  BUTTON_CLICKED: 'button:clicked',
};

const _ButtonState = {
  READY: 'Button Ready',
  IN_PROGRESS: 'In progress',
  DONE: 'Done',
};

const _ButtonType = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  DANGER: 'danger',
};

// configure
let View = BaseItemView.extend({
  template: buttonViewTemplate,
  tagName: 'a',
  className: 'btn',
  triggers: {
    click: _Events.BUTTON_CLICKED,
  },
});

// define
export default class ButtonView extends View {
  static get ButtonState() {
    return _ButtonState;
  }

  static get ButtonType() {
    return _ButtonType;
  }

  /**
   * Hides or shows the delte button.
   *
   * @param enable {boolean}  When true the button will be shown
   */
  show(enable) {
    if (enable) {
      this.$el.show();
    } else {
      this.$el.hide();
    }
  }

  /**
   * Disables/enables the button
   *
   * @param {boolean} disable     When true, the button is disabled
   */
  disable(disable) {
    if (disable) {
      this.$el.addClass('btn-disabled');
    } else {
      this.$el.removeClass('btn-disabled');
    }
  }

  /**
   * Sets the state of the button.  This will affect the appearance and behaviour
   * of the button.
   *
   * @param state {DetailView.ButtonState}    The state of the save button
   */
  setState(state) {
    switch (state) {
      case _ButtonState.IN_PROGRESS:
        this.disable(true);
        this.$el.removeClass('btn-success');
        break;

      case _ButtonState.DONE:
        this.disable(false);
        this.$el.addClass('btn-success');
        break;

      case _ButtonState.READY:
        this.disable(false);
        this.$el.removeClass('btn-success');
        break;

      default:
        this.disable(false);
        this.$el.removeClass('btn-success');
        break;
    }
  }

  /**
   * Sets the text to be displayed in the save button
   *
   * @param text {string} The localized text to display in the button
   */
  setButtonText(text) {
    this.$el.text(text);
  }
}
